/* eslint-disable max-len */
import * as fabricTypes from 'fabric'
import { fabric } from '~/utils/editor/fabric'

export const getRoundRadius = (value: number, fontSize: number, isInverse: boolean): number => {
  // Значение value инвертировано, при значениях 100 и -100 - круг будет наименьшим, при значениях, близких к 0 -
  // наибольшим. Поэтому тут мы приводим процент к нормальному виду. При этом знак нам не важен, так как он отвечает
  // только за то, внутри или снаружи круга рисуется текст и это не имеет отношения к радусу круга.
  const realPercent = 100 - Math.abs(value)
  // Коэффициент для самого маленького круга - 1.2, для наибольшего - 12.
  // Разница между этими числами - 10.8, а значит значение одного процента - 0.108
  const radiusRatio = 1.2 + 0.108 * realPercent
  const letterHeight = fontSize * 0.78
  return fontSize * radiusRatio + (isInverse ? letterHeight : 0)
}

export const getRoundPath = (
  radius: number,
  isInverse: boolean,
  isConvex: boolean,
  isRound: boolean,
  chordAngleRadians: number,
): fabricTypes.Path | undefined => {
  if (isRound) {
    return new fabric.Path(
      `M 0 0 A ${radius} ${radius} 0 ${isConvex ? 1 : 0} ${isInverse ? 0 : 1} ${2 * radius} 0 A ${radius} ${radius} 0 ${isConvex ? 1 : 0} ${isInverse ? 0 : 1} 0 0`,
      { opacity: 0 },
    )
  }
  const chord = 2 * radius * Math.sin(chordAngleRadians)
  return new fabric.Path(
    `M 0 0 A ${radius} ${radius} 0 ${isConvex ? 1 : 0} ${isInverse ? 0 : 1} ${chord} 0`,
    { opacity: 0 },
  )
}

export const getTextboxSize = (
  radius: number,
  isInverse: boolean,
  isConvex: boolean,
  isRound: boolean,
  chordAngleRadians: number,
  fontSize: number,
): {
  width: number
  height: number
} => {
  const letterHeight = fontSize * 0.78
  const bottomLetterPadding = fontSize * 0.22
  const sinChordAngleRadians = Math.sin(chordAngleRadians)
  const outlineRadius = radius + (isInverse ? -letterHeight : letterHeight)
  const chord = 2 * radius * sinChordAngleRadians
  const outlineChord = 2 * outlineRadius * sinChordAngleRadians

  if (isInverse) {
    const halfChord = chord / 2
    const halfOutlineChord = outlineChord / 2
    const height = isRound ?
      2 * radius :
      isConvex ?
        (radius + Math.sqrt(radius * radius - halfChord * halfChord)) :
        (radius - Math.sqrt(outlineRadius * outlineRadius - halfOutlineChord * halfOutlineChord))
    const width = isConvex ? (2 * radius) : chord
    return {
      height: height + bottomLetterPadding,
      width: width,
    }
  }

  const halfChord = chord / 2
  const halfOutlineChord = outlineChord / 2
  const height = isRound ?
    2 * outlineRadius :
    isConvex ?
      (outlineRadius + Math.sqrt(outlineRadius * outlineRadius - halfOutlineChord * halfOutlineChord)) :
      (outlineRadius - Math.sqrt(radius * radius - halfChord * halfChord))
  const width = isConvex ? (2 * outlineRadius) : outlineChord
  return {
    width: width,
    height: height + bottomLetterPadding,
  }
}
